import Title from 'antd/es/typography/Title';
import { editIcon } from 'assets/AssetIndex';
import { toast } from 'react-toastify';

const PropertyLayout = ({ propertyDetailData }) => {
  const handleChanges = () => {
    toast('clicked property details page');
  };
  const selectArr = ['dark', 'movie', 'film'];

  return (
    <div>
      <div className="cardCss w-3/5 flex-col p-0">
        <div className="grey flex w-full justify-between p-4">
          <Title level={5}>Building Details</Title>
          <div onClick={handleChanges} className="cursor-pointer">
            <img src={editIcon} alt="editIcon" fetchpriority="high" />
          </div>
        </div>
        <div className="p-4"></div>
      </div>
    </div>
  );
};

export default PropertyLayout;
